import { ClientInput } from 'admin/inputs/ClientInput';
import { DateInput } from 'admin/inputs/DateInput';
import { ExpectedAmountInput } from 'admin/inputs/ExpectedAmountInput';
import { InstitutionInput } from 'admin/inputs/InstitutionInput';
import { ProductStatusInput } from 'admin/products/inputs/ProductStatusInput';
import { PERIOD_TYPE_CHOICES } from 'admin/utils';
import { CollisionInsuranceRiskType, InsuringPersonType, VehicleType } from 'generated/graphql';
import { RichTextInput } from 'ra-input-rich-text';
import {
  ArrayInput,
  Create,
  FormTab,
  getRecordFromLocation,
  NumberInput,
  SelectInput,
  SimpleFormIterator,
  TabbedForm,
  TextInput,
} from 'react-admin';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { CollisionInsuranceRiskTypeTranslations } from 'translations/enums';

// TODO: generalize components

export const CollisionInsuranceProductCreate: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const record = getRecordFromLocation(location);
  return (
    <Create>
      <TabbedForm>
        <FormTab label="Základné info">
          <ClientInput disabled={!!record?.clientId} label="Klient" source="clientId" />
          <InstitutionInput source="institutionId" />
          <TextInput label="Vlastná inštitúcia" source="institutionName" sx={{ maxWidth: '40em', width: '100%' }} />
          <TextInput label="Názov produktu" source="name" sx={{ maxWidth: '40em', width: '100%' }} />
        </FormTab>

        <FormTab label="Zmluva">
          <TextInput label="Číslo zmluvy" source="contractNumber" sx={{ maxWidth: '40em', width: '100%' }} />
          <DateInput label="Začiatok poistenia" source="contractSignDate" />
          <DateInput label="Platnosť poistenia do" source="contractEndDate" />
        </FormTab>

        <FormTab label="Platby">
          <ExpectedAmountInput label="Suma poistného" source="paymentPeriod.expectedAmount.amount" />
          <TextInput source="paymentPeriod.expectedAmount.currency" style={{ display: 'none' }} value="EUR" />
          <NumberInput label="Opakovať každých" source="paymentPeriod.periodCount" />
          <SelectInput choices={PERIOD_TYPE_CHOICES} label="" source="paymentPeriod.periodTypeCode" />
          <DateInput label="Nasledujúca platba" source="paymentPeriod.expectedDate" />
        </FormTab>

        <FormTab label="Údaje pre platbu">
          <TextInput
            label="Variabilný symbol"
            source="paymentInfo.variableSymbol"
            sx={{ maxWidth: '40em', width: '100%' }}
          />
          <TextInput
            label="Špecifický symbol"
            source="paymentInfo.specificSymbol"
            sx={{ maxWidth: '40em', width: '100%' }}
          />
          <TextInput
            label="Konštantný symbol"
            source="paymentInfo.constantSymbol"
            sx={{ maxWidth: '40em', width: '100%' }}
          />
          <TextInput label="IBAN" source="paymentInfo.ibanForPayment" sx={{ maxWidth: '40em', width: '100%' }} />
        </FormTab>

        <FormTab label="Poistené vozidlo">
          <SelectInput
            choices={[
              { id: VehicleType.Automobile, name: 'Automobil' },
              { id: VehicleType.Motorcycle, name: 'Motocykel' },
              { id: VehicleType.Other, name: 'Iné' },
            ]}
            label="Typ vozidla"
            source="vehicleInfo.type"
          />
          <NumberInput label="Rok výroby" source="vehicleInfo.manufactureYear" />
          <TextInput label="ŠPZ" source="vehicleInfo.licenseNumber" />
        </FormTab>

        <FormTab label="Poistené riziká">
          <ArrayInput label="Poistené riziká" source="insuranceRisks">
            <SimpleFormIterator inline>
              <SelectInput
                choices={[
                  CollisionInsuranceRiskType.Accident,
                  CollisionInsuranceRiskType.NaturalDisaster,
                  CollisionInsuranceRiskType.Theft,
                  CollisionInsuranceRiskType.Vandalism,
                  CollisionInsuranceRiskType.Other,
                ].map((type) => ({
                  id: type,
                  name: CollisionInsuranceRiskTypeTranslations(t)[type],
                }))}
                helperText={false}
                label="Typ rizika"
                source="type"
              />
              <TextInput
                helperText={false}
                label="Názov rizika"
                source="name"
                sx={{ maxWidth: '40em', width: '100%' }}
              />
              <NumberInput helperText={false} label="Poistná suma" source="insuredSum.amount" />
              <NumberInput helperText={false} label="Poistné" source="annualCost.amount" />
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>

        <FormTab label="Poistník">
          <SelectInput
            choices={[
              { id: InsuringPersonType.Natural, name: 'Fyzická osoba' },
              { id: InsuringPersonType.Legal, name: 'Právnická osoba' },
            ]}
            label="Typ poistníka"
            source="insuringPerson.type"
          />
          <TextInput
            label="Názov spoločnosti / Meno"
            source="insuringPerson.name"
            sx={{ maxWidth: '40em', width: '100%' }}
          />
        </FormTab>

        <FormTab label="Údaje pre porovnanie výhodnosti produktu">
          <DateInput label="Dátum narodenia" source="vehicleInfo.owner.dateOfBirth" />
          <TextInput label="PSČ" source="vehicleInfo.owner.postalCode" />
          <NumberInput label="Rok poslednej nehody" source="vehicleInfo.owner.yearOfLastCollision" />
          <NumberInput label="Počet nehôd za 3 roky" source="vehicleInfo.owner.numberOfRecentCollisions" />
        </FormTab>

        <FormTab label="Status">
          <ProductStatusInput label="Status" source="status" />
        </FormTab>

        <FormTab label="Poznámka">
          <RichTextInput
            label="Poznámka"
            source="note"
            sx={{ '& .tiptap': { minHeight: '20em' }, maxWidth: '40em', width: '100%' }}
          />
        </FormTab>
      </TabbedForm>
    </Create>
  );
};
